import React from 'react';
import { IPartner } from '@whitelabel/helpers/types';
import {
  StyledPartnerHeading,
  StyledTitle,
  StyledPartner,
  StyledPartnerLogo,
  StyledTitleBox,
} from './styledPartnerHeading';

export interface IPartnerHeading {
  title?: string;
  logo?: string;
  partner?: IPartner;
  className?: string;
  children?: React.ReactNode;
  titleSubcontent?: React.ReactNode;
  titleTag?: keyof JSX.IntrinsicElements;
}

const PartnerHeading = ({
  title,
  logo,
  partner,
  className,
  children,
  titleSubcontent,
  titleTag = 'h2',
}: IPartnerHeading): JSX.Element => {
  const TitleTag = titleTag;
  return (
    <StyledPartnerHeading className={className} data-test-id="PartnerHeading">
      {titleSubcontent ? (
        <StyledTitleBox>
          <TitleTag className="h2" data-test-id="PartnerHeading-title">
            {title}
          </TitleTag>
          {titleSubcontent}
        </StyledTitleBox>
      ) : (
        <StyledTitle as={titleTag} className="h2" data-test-id="PartnerHeading-title">
          <span>{title}</span>
        </StyledTitle>
      )}

      {logo && (
        <StyledPartner data-test-id="PartnerHeading-partner">
          <StyledPartnerLogo src={logo} alt={partner?.title} data-test-id="PartnerHeading-partnerLogo" />
        </StyledPartner>
      )}

      {children}
    </StyledPartnerHeading>
  );
};

export default PartnerHeading;
